import { render, staticRenderFns } from "./ListPlanCategory.vue?vue&type=template&id=274d6814&"
import script from "./ListPlanCategory.vue?vue&type=script&lang=js&"
export * from "./ListPlanCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports